import React from "react";

export default function Description({ text, style, className }) {
  return (
    <div
      className={className}
      style={{
        flex: 1,
        backgroundColor: "#E4ECF2",
        padding: 8,
        borderRadius: 6,
        alignItems: "center",
        fontSize: 11,
        display: "flex",
        ...style,
      }}
    >
      {text}
    </div>
  );
}
